import { useState } from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const NumericInput = ({ initialValue, min, max, handleChange }) => {
  const [hoverPlus, setHoverPlus] = useState(false);
  const [hoverMinus, setHoverMinus] = useState(false);

  const [value, setValue] = useState(initialValue);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "600",
        backgroundColor: "#4F79C9",
        color: "white",
        borderRadius: "20px",
        width: "84px",
        heigth: "22px",
        padding: "0 4px",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        boxSizing: "border-box",
      }}
    >
      <button
        onClick={() => {
          const newValue = value > min ? value - 1 : value;
          setValue(newValue);
          handleChange(newValue);
        }}
        style={{
          border: "none",
          color: "white",
          backgroundColor: hoverMinus ? "#3A5BA0" : "#4F79C9",
          borderRadius: "20px",
          cursor: value > min ? "pointer" : "not-allowed",
        }}
        disabled={value <= min}
        onMouseEnter={() => setHoverMinus(true)}
        onMouseLeave={() => setHoverMinus(false)}
      >
        <MinusOutlined color="white" style={{ fontSize: "15px" }} />
      </button>
      <span style={{ width: "28px", textAlign: "center" }}>{value}</span>
      <button
        onClick={() => {
          const newValue = value + 1;
          setValue(newValue);
          handleChange(newValue);
        }}
        style={{
          border: "none",
          color: "white",
          backgroundColor: hoverPlus ? "#3A5BA0" : "#4F79C9",
          borderRadius: "20px",
          cursor: "pointer",
        }}
        disabled={value >= max}
        onMouseEnter={() => setHoverPlus(true)}
        onMouseLeave={() => setHoverPlus(false)}
      >
        <PlusOutlined color="white" style={{ fontSize: "15px" }} />
      </button>
    </div>
  );
};

export { NumericInput };
